<template>
  <div class="hostelhistory-container">
    <template v-for="i in searchInput">
      <el-input
        :key="i.model"
        v-model="search[i.model]"
        style="width: 200px; margin-right: 10px"
        :placeholder="i.label"
        size="small"
      ></el-input>
    </template>
    <el-date-picker
      v-model="search.date"
      type="daterange"
      :clearable="false"
      range-separator="-"
      :start-placeholder="$t('app.checkOutSearchStartTime')"
      :end-placeholder="$t('app.checkOutSearchEndTime')"
      size="small"
      style="margin-right: 10px"
    >
    </el-date-picker>
    <el-button type="primary" @click="reset" size="small">{{
      $t("app.reset")
    }}</el-button>
    <el-button
      type="success"
      @click="getList"
      icon="el-icon-search"
      size="small"
      >{{ $t("app.search") }}</el-button
    >
    <div class="table-container">
      <el-table
        :data="tableData"
        height="620"
        style="width: 100%; color: black"
        @sort-change="sortChange"
      >
        <el-table-column
          align="left"
          width="150px"
          :label="$t('app.operation')"
        >
          <template slot-scope="scope">
            <!-- <el-button
              v-if="scope.row.applyStatus === '1'"
              size="small"
              type="danger"
              @click="recover(scope.row)"
              >{{ $t("app.recover") }}</el-button
            > -->
            <el-button size="small" type="success" @click="view(scope.row)">{{
              $t("app.viewDetails")
            }}</el-button>
          </template>
        </el-table-column>
        <template v-for="col in column">
          <el-table-column
            v-if="
              col.model === 'applyTime' ||
              col.model === 'studentApplicationCode'
            "
            :key="col.model"
            align="center"
            :label="col.label"
            :prop="col.model"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            v-else
            :key="col.model"
            align="center"
            :label="col.label"
            :prop="col.model"
          >
          </el-table-column>
        </template>
      </el-table>
    </div>
    <el-pagination
      style="text-align: center; margin-top: 20px"
      background
      :total="total"
      :current-page.sync="currentPage"
      @size-change="handleSizeChange"
      @current-change="getList"
      :page-sizes="[10, 50, 200, 1000]"
      :page-size="size"
      layout="total, sizes, prev, pager, next"
    >
    
    </el-pagination>
    <old-student-details-modal
      ref="oldstudentdetailsModal"
    ></old-student-details-modal>
    <new-student-details-modal
      ref="newstudentdetailsModal"
    ></new-student-details-modal>
  </div>
</template>

<script>
import {
  getList,
  recover,
  getNewStudent,
  getOldStudent,
} from "@/api/dormitoryManagement/studentApplication";
import { delEmpty } from "@/utils/utils";
import OldStudentDetailsModal from "./modules/DetailsModal";
import NewStudentDetailsModal from "./modules/DetailsModalNew";
export default {
  components: {
    OldStudentDetailsModal,
    NewStudentDetailsModal,
  },
  data() {
    return {
      auto: false,
      time: "",
      loading: false,
      searchInput: [
        { model: "studentNumber", label: this.$t("app.studentAndApplication") },
        { model: "name", label: this.$t("app.nameEnglish") },
      ],
      column: [
        {
          model: "studentApplicationCode",
          label: this.$t("app.studentAndApplication"),
        },
        { model: "name", label: this.$t("app.nameEnglish") },
        {
          model: "roomName",
          label: this.$t("app.roomCode"),
        },
        {
          model: "statusDisplay",
          label: this.$t("app.applyStatus"),
        },
        {
          model: "applyTime",
          label: this.$t("app.applyTime"),
        },
      ],
      search: {
        studentNumber: "",
        name: "",
        date: [],
        orderKey: "",
        orderType: "",
      },
      size: 10,
      currentPage: 1,
      total: 100,
      tableData: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      getList(
        delEmpty({
          StudentApplicationCode: this.search.studentNumber,
          Name: this.search.name,
          SubmitDateSearchBegin: this.search.date[0] || "",
          SubmitDateSearchEnd: this.search.date[1] || "",
          PageIndex: this.currentPage,
          PageSize: this.size,
          OrderKey: this.search.orderKey,
          OrderType: this.search.orderType,
        })
      ).then((res) => {
        this.total = res.data.Total;
        if (res.data.Items == null) {
          this.tableData = [];
          this.total = 0;
          return;
        }

        this.tableData = res.data.Items.map((item) => {
          return {
            id: item.Id,
            studentApplicationCode: item.StudentApplicationCode,
            statusDisplay: item.StatusDisplay,
            name: item.Name,
            roomName: item.Room,
            applyTime: item.CreateTime,
            applyStatus: item.Status,
            isNewStudent: item.IsNewStudent,
          };
        });
      });
    },
    reset() {
      this.search.studentNumber = "";
      this.search.name = "";
      this.search.date = [];
    },
    handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
    sortChange(obj) {
      this.search.orderKey = obj.prop;
      this.search.orderType = obj.order;
      this.getList();
    },
    recover(row) {
      this.$confirm(this.$t("app.recoverModification") + "?").then(() => {
        recover({
          Id: row.id,
          IsNewStudent: row.isNewStudent,
        }).then(() => {
          this.success();
        });
      });
    },
    view(row) {
      if (row.isNewStudent) {
        getNewStudent(
          delEmpty({
            Id: row.id,
            IsNewStudent: row.isNewStudent,
          })
        ).then((res) => {
          let data = {
            applicationNumber: res.data.ApplicationCode,
            arrivalDate: res.data.ArrivalDate,
            bed: res.data.Bed,
            bedState: res.data.BedState,
            bedColor: res.data.BedStateColor,
            nameChina: res.data.ChineseName,
            contactInformation: res.data.ContactMobile,
            departureDate: res.data.DepartureDate,
            departurePort: res.data.DeparturePort,
            departureTime: res.data.DepartureTime,           
            email: res.data.Email,
            status: res.data.DebitState,
            firstName: res.data.FirstName,
            filghtNumber: res.data.FlightNumber,
            nameEnglish: res.data.FullName,
            gender: res.data.Gender,
            lastName: res.data.LastName,
            meetAddress: res.data.MeetAddress,
            meetService: res.data.MeetService,
            mobile: res.data.Mobile,
            nationCode: res.data.NationCode,
            originalSchool: res.data.OriginalSchool,
            requirement: res.data.OtherRequirement,
            planArrivalTime: res.data.PlanArrivalTime,
            room: res.data.RoomIndex,
            roomMateRequirement: res.data.RoomMateRequirement,
            roomState: res.data.RoomState,
            roomType: res.data.RoomType,
            roomColor: res.data.RoomTypeColor,
            roomTypeRequirement: res.data.RoomTypeRequirement,
            selectedRoomMateType: res.data.SelectedRoomMateType,
            selectedRoomType: res.data.SelectedRoomType,
            studentNumber: res.data.StudentCode,
            personColor: res.data.SpecialTypeColor,
            studentSpecialType: res.data.StudentSpecialType,
            debitNo: res.data.DebitNo,
            otherName: res.data.OtherName,
            specialTypeDetail: res.data.SpecialTypeDetail,
            native: res.data.StudentNative,
            programme: res.data.Programme,
            haveFee: res.data.HaveFee,
          };
          //console.log("PlanArrivalTime: " + data.PlanArrivalTime)
          this.$refs.newstudentdetailsModal.edit(data);
        });
      } else {
        getOldStudent(
          delEmpty({
            Id: row.id,
            IsNewStudent: row.isNewStudent,
          })
        ).then((res) => {
          let data = {
            checkOutDate: res.data.CheckOutDate,
            currentRoom: res.data.CurrentRoom,
            nameEnglish: res.data.FullName,
            isContinueLodge: res.data.IsContinueLodge,
            isContinueSameRoom: res.data.IsContinueSameRoom,
            isKeep: res.data.IsKeepRoom,
            requirement: res.data.OtherRequirement,
            changeType: res.data.RoomChangeType,
            studentNumber: res.data.StudentCode,
            selectedRoomType: res.data.SelectedRoomType,
            roomType: res.data.RoomType,
          };
          this.$refs.oldstudentdetailsModal.edit(data);
        });
      }
    },
    success() {
      this.$message({
        message: this.$t("app.opeSuccess"),
        type: "success",
      });
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.hostelhistory-container {
  background-color: #fff;
  padding: 15px;
  border: solid 1px #ccc;
  height: calc(100% - 100px);
  .table-container {
    height: calc(100% - 150px);
    overflow: auto;
  }
}
</style>
